import React from 'react';
import PropTypes from 'prop-types';
import './content-divider.scss';
import clsx from 'clsx';

const ContentPosition = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
  SPACEBETWEEN: 'spacebetween',
};

const ContentDivider = ({ primaryContent, secondaryContent, position }) => (
  <div
    className={clsx(
      'content-divider-content',
      position,
      { 'no-content': !primaryContent && !secondaryContent },
    )}
  >
    {primaryContent}
    {primaryContent && secondaryContent && position === ContentPosition.SPACEBETWEEN
      && <div className="content-divider-content-border" />}
    {secondaryContent}
  </div>
);

ContentDivider.defaultProps = {
  primaryContent: null,
  secondaryContent: null,
  position: ContentPosition.CENTER,
};

ContentDivider.propTypes = {
  primaryContent: PropTypes.node,
  secondaryContent: PropTypes.node,
  position: PropTypes.oneOf(Object.values(ContentPosition)),
};

export {
  ContentDivider as default,
  ContentPosition,
};
